export default "__VITE_ASSET__K0iv5ukx__"